import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { cartApi } from "../api/cartApi";
import Message from "../components/Message";

export default function Cart({ user, onCartUpdate }) {
  const [cart, setCart] = useState({ items: [], total: 0 });
  const [notice, setNotice] = useState(null);

  useEffect(() => {
    loadCart();
  }, [user]);

  async function loadCart() {
    try {
      const data = await cartApi.getCart();
      setCart({ items: data.cart_items || data.items || [], total: data.total || 0 });
    } catch (error) {
      setNotice({ type: "error", text: error.message });
    }
  }

  async function updateQuantity(productId, quantity) {
    try {
      await cartApi.updateCart(productId, Number(quantity));
      await loadCart();
      if (onCartUpdate) {
        const updatedCart = await cartApi.getCart();
        const count = updatedCart.items 
          ? updatedCart.items.reduce((total, item) => total + item.quantity, 0)
          : 0;
        onCartUpdate(count);
      }
    } catch (error) {
      setNotice({ type: "error", text: error.message });
    }
  }

  async function removeItem(productId) {
    try {
      await cartApi.removeFromCart(productId);
      await loadCart();
      if (onCartUpdate) {
        const updatedCart = await cartApi.getCart();
        const count = updatedCart.items 
          ? updatedCart.items.reduce((total, item) => total + item.quantity, 0)
          : 0;
        onCartUpdate(count);
      }
    } catch (error) {
      setNotice({ type: "error", text: error.message });
    }
  }

  return (
    <div className="cart-container">
      <div className="container">
        <h1 className="page-title">Shopping Cart</h1>
        <Message notice={notice} />

        {cart.items.length > 0 ? (
          <div className="cart-content">
            <div className="cart-items">
              <table className="cart-table">
                <thead>
                  <tr>
                    <th>Product</th>
                    <th>Price</th>
                    <th>Quantity</th>
                    <th>Subtotal</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {cart.items.map((item) => (
                    <tr className="cart-item" key={item.product_id}>
                      <td className="product-name">{item.name}</td>
                      <td className="product-price">${Number(item.price).toFixed(2)}</td>
                      <td className="product-quantity">
                        <input
                          type="number"
                          className="quantity-input"
                          min="1"
                          value={item.quantity}
                          onChange={(event) => updateQuantity(item.product_id, event.target.value)}
                        />
                      </td>
                      <td className="product-subtotal">${(Number(item.price) * Number(item.quantity)).toFixed(2)}</td>
                      <td>
                        <button className="btn btn-sm btn-danger" onClick={() => removeItem(item.product_id)}>
                          Remove
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="cart-summary">
              <h3>Order Summary</h3>
              <div className="summary-row"><span>Subtotal:</span><span className="subtotal">${Number(cart.total).toFixed(2)}</span></div>
              <div className="summary-row"><span>Shipping:</span><span className="shipping">Free</span></div>
              <div className="summary-row total"><span>Total:</span><span className="total-price">${Number(cart.total).toFixed(2)}</span></div>

              {user ? (
                <Link to="/checkout" className="btn btn-primary btn-block" style={{ marginTop: 20 }}>Proceed to Checkout</Link>
              ) : (
                <Link to="/login?role=customer" className="btn btn-primary btn-block" style={{ marginTop: 20 }}>Login to Checkout</Link>
              )}

              <Link to="/shop" className="btn btn-secondary btn-block" style={{ marginTop: 10 }}>Continue Shopping</Link>
            </div>
          </div>
        ) : (
          <div className="empty-cart">
            <p>Your cart is empty</p>
            <Link to="/shop" className="btn btn-primary">Start Shopping</Link>
          </div>
        )}
      </div>
    </div>
  );
}
